import React from "react";
import { Fragment } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PageHeader from "./layout/component/header";
import PageFooter from "./layout/component/footer";
import Payment from "./layout/pages/online-payment";
import Miscellaneous from "./layout/pages/miscellaenous";
import RealProperty from "./layout/pages/realproperty";
// import Cedula from "./layout/pages/cedula";
import RequestBilling from "./layout/pages/request-billing";
// import Home from "./layout/pages/home";
import NotFound from "./layout/pages/not-found";

const AppRoutes = (props) => {
  return (
    <BrowserRouter>
      <PageHeader />
      <div id="page-content">
        <Routes>
          {/* <Redirect exact from="/" to="/request-billing" /> */}

          {/* <Route exact path="/home" component={Home} /> */}

          {/* <Route
              exact
              path="/cedula"
              component={() => <Cedula {...props} />}
            /> */}

          <Route
            exact
            path="/request-billing"
            element={<RequestBilling {...props} />}
          />

          <Route exact path="/payment" element={<Payment {...props} />} />

          <Route
            exact
            path="/payment/misc/:bill_no"
            element={<Miscellaneous {...props} />}
          />

          <Route
            exact
            path="/payment/rpt/:bill_no"
            element={<RealProperty {...props} />}
          />

          <Route component={NotFound} />
        </Routes>
      </div>
      <PageFooter {...props} />
    </BrowserRouter>
  );
};

export default AppRoutes;
